import React, { createElement, FunctionComponent } from 'react';
import { useTranslate } from 'react-admin';
import { Link as MuiLink } from '@material-ui/core';
import { UrlFieldProps } from './types';
import { getIconComponentFromName } from '../../helpers/icons';

const UrlField: FunctionComponent<UrlFieldProps> = (props) => {
  const { record, source, icon, linkLabel } = props;
  const translate = useTranslate();

  if (!record || !source || !record[source]) return null;

  const IconComponent = getIconComponentFromName(icon);
  const link = record[source];

  // `linkLabel` (a translation key) replaces a long URL (e.g. a Google Doc's);
  // a URL shown as is wraps instead of overflowing its section
  const content = IconComponent
    ? createElement(IconComponent)
    : linkLabel
    ? translate(linkLabel)
    : link;

  return (
    <MuiLink
      href={link}
      target="_blank"
      rel="noopener"
      style={{ wordBreak: 'break-all' }}
    >
      {content}
    </MuiLink>
  );
};

export default UrlField;
